import { staticConfig } from "@fidget/common/config/static-config";
import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { CheckBoxInputFieldState } from "@fidget/common/components/form/checkboxInput";
import { EventPicker } from "@fidget/common/components/form/eventPicker/eventPicker";
import { intl } from "@fidget/common/i18n/TypedIntl";
import settingsStyles from "../../../../../styles/settings.css";
import { MessageWidgetsPicker } from "../../../../forms/messageWidgetsPicker/messageWidgetsPicker";
import { TagGroupPicker } from "../../../../forms/tagPicker/tagGroupPicker";
import { VerticalSeparator } from "../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import { ExistingActionFormType, NewActionFormType } from "../../types";
import { EventActionResponseInput } from "../responseInput/eventActionResponseInput";
import styles from "./newEventActionBox.css";
import { LanguageOption } from "@fidget/common/components/form/languagePicker/languagePicker";

interface Props {
  form: NewActionFormType | ExistingActionFormType;
  id?: string;
  currentLanguage: LanguageOption;
}

export const NewEventActionBox = observer(({ form, id, currentLanguage }: Props) => {
  return (
    <div className={settingsStyles.flex}>
      <div className={settingsStyles["flex-column"]}>
        <span className={classNames(settingsStyles["form-label-font"], styles["label-margin"])}>
          {intl.formatMessage("settings.eventActions.form.event")}
        </span>
        <EventPicker
          onChange={(e) => form.$.event.onChange(e)}
          currentEvent={form.$.event.$ ? form.$.event.$ : undefined}
          className={settingsStyles["input-width"]}
        />
        <TagGroupPicker
          onClearSelected={form.$.tagGroupId.$ ? () => form.$.tagGroupId.reset("") : undefined}
          tagGroupId={form.$.tagGroupId.$}
          onChange={(tg) => form.$.tagGroupId.reset(tg.id)}
          className={classNames(settingsStyles["input-width"], styles["inputs-margin"])}
          placeholder={intl.formatMessage("settings.eventActions.form.tagGroup.placeholder")}
        />
      </div>
      <VerticalSeparator />
      <div className={settingsStyles["flex-column"]}>
        <span className={classNames(settingsStyles["form-label-font"], styles["label-margin"])}>
          {intl.formatMessage("settings.eventActions.form.response")}
        </span>
        <div className={styles["input-with-description"]}>
          <EventActionResponseInput field={form.$.response} />
          <span className={settingsStyles["form-description-font"]}>
            {intl.formatMessage("maxCharacters", {
              limit: staticConfig.eventActionsMessageMaxCharacters
            })}
          </span>
        </div>
        <MessageWidgetsPicker
          locale={currentLanguage}
          messageWidgetId={form.$.widgetId.$}
          onClearSelected={form.$.widgetId.$ ? () => form.$.widgetId.reset("") : undefined}
          onChange={(widget) => form.$.widgetId.reset(widget.id)}
          className={classNames(settingsStyles["input-width"], styles["inputs-margin"])}
        />
        {form.$.widgetId.$ && (
          <CheckBoxInputFieldState
            field={form.$.widgetBlockInput}
            id={id + "event-action-block-input"}
            label={intl.formatMessage("settings.eventActions.form.blockInput.description")}
            smallStyle
            displayNoColors
            noMarginBottom
            className={styles["inputs-margin"]}
          />
        )}
      </div>
    </div>
  );
});
